import Api from "@/api/index";
// import store from "@/store";
// import alerts from "@/components/alerts/alert";
// import router from "@/router";

const menus = {
  namespaced: true,
  state: {
    datas: {},
    queryParam: {},
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
  },
  actions: {
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("menus/page", payload).then(({ data }) => {
        commit("SET_DATAS", data);
        commit("SET_LOADING", false);
      });
    },
    // async paginate({ commit }, payload) {
    //   commit("SET_LOADING", payload.loading);
    //   commit("SET_QUERY_PARAM", payload.datas);
    //   return await Api.doGet(
    //     "roles/page", payload.datas
    //   ).then(({ data }) => {
    //     commit("SET_DATAS", data);
    //     commit("SET_DATA", data.data.data);
    //     commit("SET_LOADING", false);
    //   });
    // },
    setIsAactiveFalse({ commit, state }) {
      const menuNew = state.sidebar;
      menuNew.forEach((element, i) => {
        if (element.slug === "dropdown") {
          menuNew[i].isActive = false;
        }
      });
      commit("SET_SIDEBAR", menuNew);
    },
  },
};

export default menus;
